export default __webpack_public_path__ + "navigation-examples-advanced-1200-8413f4b2b62b24adfbe023612ea8f99f.webp";